import { useState } from 'react';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { CalendarCheck, Loader2 } from 'lucide-react';
import { SelectedSlot } from '../../types/slots';
import { SlotTime } from './slot-time';

interface RescheduleFormProps {
  onSubmit: (reason: string) => void;
  onBack: () => void;
  slot: SelectedSlot | undefined;
  isSubmitting: boolean;
}

export function RescheduleForm({
  onSubmit,
  onBack,
  slot,
  isSubmitting,
}: RescheduleFormProps) {
  const [reason, setReason] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!reason.trim()) return;
    onSubmit(reason);
  };

  return (
    <div className="p-6">
      <div className="max-w-xl mx-auto">
        <form onSubmit={handleSubmit} className="space-y-6">
          <SlotTime slot={slot}></SlotTime>
          <div className="space-y-2">
            <label htmlFor="reason" className="text-sm font-medium">
              Rescheduling Reason
            </label>
            <Textarea
              id="reason"
              placeholder="Please provide a reason for rescheduling..."
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="min-h-[120px]"
              required
            />
          </div>
          <div className="flex flex-row gap-4">
            <Button type="submit" disabled={isSubmitting}>
              {isSubmitting ? (
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              ) : (
                <CalendarCheck className="mr-2 h-4 w-4" />
              )}
              Confirm Reschedule
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
